import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Tag from '@groovehq/internal-design-system/lib/components/Tag/Tag'
import { selectCurrentSubmittedTicketSearchFilterMatches } from 'selectors/search/searchFilters'
import { selectCurrentCommittedTicketSearchQueryString } from 'selectors/search'
import { doSubmitTicketsSearch } from 'actions/search'
import { propFunc } from 'util/functions'
import { styles } from '../styles'

const FilterBadges = () => {
  const dispatch = useDispatch()
  const currentCommittedTicketSearchQueryString = useSelector(
    selectCurrentCommittedTicketSearchQueryString
  )
  const matches = useSelector(selectCurrentSubmittedTicketSearchFilterMatches)

  const handleRemoveFilter = useCallback(
    filter => {
      const remainingSubmittedFilters = matches.filter(item => item !== filter)
      dispatch(
        doSubmitTicketsSearch(
          [
            ...remainingSubmittedFilters,
            currentCommittedTicketSearchQueryString,
          ]
            .filter(Boolean)
            .join(' '),

          { shouldIncludeMailboxSearch: true }
        )
      )
    },
    [dispatch, matches, currentCommittedTicketSearchQueryString]
  )

  if (!matches.length) return null

  return (
    <div className="grui p-5 pl-8 flex flex-wrap" css={styles.filterBadges}>
      {matches.map((match, index) => (
        <Tag
          closable
          css={styles.filterBadge}
          key={match}
          onClose={propFunc(handleRemoveFilter, match, index)}
        >
          {match}
        </Tag>
      ))}
    </div>
  )
}

export default FilterBadges
